/** Runtime kill switch — default off until explicitly enabled (playback-safety §2.6). */
export const PLAYER_DIAGNOSTICS_ENABLED_STORAGE_KEY = 'LUCIMARK:PLAYER_DIAGNOSTICS_ENABLED'

/** Node 22+ may define `localStorage` without usable getItem/setItem (experimental / --localstorage-file). */
function playerDiagnosticsLocalStorage(): Storage | null {
  if (typeof localStorage === 'undefined') {
    return null
  }
  if (
    typeof localStorage.getItem !== 'function'
    || typeof localStorage.setItem !== 'function'
    || typeof localStorage.removeItem !== 'function'
  ) {
    return null
  }
  return localStorage
}

export function isPlayerDiagnosticsKillSwitchEnabled(): boolean {
  const store = playerDiagnosticsLocalStorage()
  if (store == null) {
    return false
  }
  return store.getItem(PLAYER_DIAGNOSTICS_ENABLED_STORAGE_KEY) === 'true'
}

export function setPlayerDiagnosticsKillSwitchEnabled(enabled: boolean): void {
  const store = playerDiagnosticsLocalStorage()
  if (store == null) {
    return
  }
  if (enabled) {
    store.setItem(PLAYER_DIAGNOSTICS_ENABLED_STORAGE_KEY, 'true')
  }
  else {
    store.removeItem(PLAYER_DIAGNOSTICS_ENABLED_STORAGE_KEY)
  }
}

let diagnosticSessionActiveUntilMs = 0

export function armPlayerDiagnosticSession(untilMs: number): void {
  diagnosticSessionActiveUntilMs = untilMs
  setPlayerDiagnosticsKillSwitchEnabled(true)
}

export function getPlayerDiagnosticSessionActiveUntilMs(): number {
  return diagnosticSessionActiveUntilMs
}

export function isPlayerDiagnosticsSamplingEnabled(nowMs = Date.now()): boolean {
  if (diagnosticSessionActiveUntilMs > nowMs) {
    return true
  }
  return isPlayerDiagnosticsKillSwitchEnabled()
}

export function resetPlayerDiagnosticSessionForTests(): void {
  diagnosticSessionActiveUntilMs = 0
}
